<template>
  <router-view v-slot="{ Component, route }">
    <transition mode="out-in" :name="theme.showPageTransition ? 'fade-transform' : 'no-transform'">
      <!-- 只保留当前页面，切换时淘汰旧实例，同时兼容已有的 onActivated 数据加载。 -->
      <keep-alive :max="1">
        <component :is="Component" :key="`${route.fullPath}:${refreshKey}`" />
      </keep-alive>
    </transition>
  </router-view>
</template>

<script>
  import { computed, defineComponent, getCurrentInstance, nextTick, onBeforeMount, onUnmounted, ref } from 'vue'
  import { useStore } from 'vuex'
  import VabProgress from 'nprogress'

  export default defineComponent({
    name: 'VabRouterView',
    setup() {
      const store = useStore()
      const theme = computed(() => store.getters['settings/theme'])
      const { proxy } = getCurrentInstance()
      const refreshKey = ref(0)

      // 标签页只记录导航入口，不再决定页面实例的缓存。
      // fullPath 包含业务参数，避免不同会议/记录复用同一个页面实例。
      const reload = async () => {
        const showProgressBar = theme.value.showProgressBar
        if (showProgressBar) VabProgress.start()
        refreshKey.value += 1
        await nextTick()
        if (showProgressBar) VabProgress.done()
      }

      onBeforeMount(() => {
        proxy.$sub('reload-router-view', reload)
      })

      onUnmounted(() => {
        proxy.$unsub('reload-router-view', reload)
      })

      return {
        theme,
        refreshKey,
      }
    },
  })
</script>
